import React from 'react'
import { Edit3 } from 'lucide-react'
import WorkPanelWrapper from '../common/WorkPanelWrapper'

interface DataViewProps {
  extractedData: Record<string, any>
  onEditField?: (key: string, value: any) => void
}

const DataView: React.FC<DataViewProps> = ({
  extractedData,
  onEditField
}) => {
  const formatValue = (value: any): string => {
    if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value, null, 2)
    }
    return String(value)
  }

  const formatFieldName = (key: string): string => {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }

  return (
    <WorkPanelWrapper title="Extracted Data">
      <div className="">
        <div className="space-y-4">
          {Object.entries(extractedData).map(([key, value]) => (
            <div 
              key={key} 
              className="flex items-center space-x-4 p-3 bg-gray-50 rounded-lg border border-gray-200"
            >
              <div className="w-32 text-sm font-medium text-gray-700">
                {formatFieldName(key)}
              </div>
              <div className="flex-1">
                {typeof value === 'object' ? (
                  <pre className="text-sm text-gray-600 overflow-x-auto">
                    {formatValue(value)}
                  </pre>
                ) : (
                  <div className="text-sm font-mono text-gray-900">
                    {formatValue(value)}
                  </div>
                )}
              </div>
              {onEditField && (
                <button 
                  onClick={() => onEditField(key, value)}
                  className="p-1 hover:bg-gray-200 rounded"
                >
                  <Edit3 className="w-4 h-4" />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </WorkPanelWrapper>
  )
}

export default DataView
